import React, { useState } from "react";
import useCurrentAccountStore from "./AccountStore";
import AccountHook from "./AccountHook";
import shallow from "zustand/shallow";
import { useFormContext } from "react-hook-form";
import Swal from "sweetalert2";
import { saveAccountTable } from "./AccountAPI";
import history from "utils/createBrowserHistory";
import { PATHS } from "../constants/Constants";
import { useUserBhphPrivileges } from "../features/settings/subFeatures/settingsTabs/userManagement/useUserPrivileges";
import { showApiError } from "../utils/errorRoutingUtils";
import { saveFailAlert } from "../utils/alertUtils";

export const AccountSaveButton = ({ modifyAccount }) => {
	console.log(modifyAccount);
	const [isSaving, setIsSaving] = useState(false);
	const privileges = useUserBhphPrivileges();
	const p = privileges();
	const hasPermission = p.editAccount;
	const { account } = useCurrentAccountStore(
		(state) => ({
			account: state.account,
		}),
		shallow
	);
	const save = AccountHook();
	//console.log(account);
	const saveData = async () => {
		if (account.buyerRecNum === null) {
			await Swal.fire(" Please select a customer first", "error");
			return;
		}
		setIsSaving(true);
		try {
			await save();
			if (modifyAccount) {
				console.log(modifyAccount);
				saveAccountTable(modifyAccount).then(
					(response) => {
						console.log(response);
						setIsSaving(false);
						history.push(PATHS.ACCT_DETAIL, {
							acctID: modifyAccount.id,
						});
					},

					(err) => {
						console.log(err);
						setIsSaving(false);
						if (!err.isGeneralError) {
							showApiError(err, saveFailAlert);
						}
					}
				);
			} else {
				setIsSaving(false);
			}
		} catch (err) {
			console.error("Error saving account:", err);
			setIsSaving(false);
			if (!err.isGeneralError) {
				showApiError(err, saveFailAlert);
			}
		}
	};
	const methods = useFormContext();
	return (
		<>
			<div
				className="btn btn-success float-button"
				onClick={methods.handleSubmit(saveData, (err) => {
					console.log(err);
				})}
				disabled={!hasPermission || isSaving}
			>
				<i className="nc-icon nc-check-2"></i>&nbsp;
				{isSaving
					? "Saving..."
					: account.id != null
					? "Update Account"
					: "Generate Account"}
			</div>
		</>
	);
};

export default AccountSaveButton;
